// RecognitionsSection.jsx
'use client';
import Image from "next/image";
import UGC from "@/assets/logo/UGC.png";
import NSDC from "@/assets/logo/NSDC.png";
import NCVET from "@/assets/logo/NCVET.png";
import GovtSikkim from "@/assets/logo/Govt-of-Sikkim.png";
import DGT from "@/assets/logo/DGT.png";
import AIU from "@/assets/logo/AIU.png";
import ISO2018 from "@/assets/logo/ISO2018.png";
import NAPS from "@/assets/logo/NAPS.png";
import NATS from "@/assets/logo/NATS.png";
import PCI from "@/assets/logo/PCI.png";
import SNC from "@/assets/logo/SNC.png";
import paramedicalcouncil from "@/assets/logo/paramedicalcouncil.png";
const logos = [
  { src: UGC, alt: "UGC" },
  { src: NSDC, alt: "NSDC" },
  { src: NCVET, alt: "NCVET" },
  { src: GovtSikkim, alt: "Govt-of-Sikkim" },
  { src: DGT, alt: "DGT" },
  { src: AIU, alt: "AIU" },
  { src: ISO2018, alt: "ISO2018" },
  { src: NAPS, alt: "NAPS" },
  { src: NATS, alt: "NATS" },
  { src: PCI, alt: "PCI" },
  { src: SNC, alt: "SNC" },
  { src: paramedicalcouncil, alt: "Paramedical Council" },
];

export function RecognitionsSection() {
  return (
    <section className="relative py-10 md:py-14 bg-gradient-to-b from-white via-slate-50/60 to-white">
      <div className="relative max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Heading */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-slate-400 mb-2">
            Trusted by Leading Bodies
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-slate-900">
            Recognitions &amp; Accreditations
          </h2>
        </div>

        {/* Logos wrapper */}
        <div className="relative rounded-3xl border border-slate-100 bg-white/80 backdrop-blur-sm shadow-[0_18px_45px_rgba(15,23,42,0.08)] px-4 md:px-6 lg:px-8 py-5 md:py-6">
          {/* subtle top gradient line */}
          <div className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-sky-200/80 to-transparent" />

          {/* Logos: horizontally scrollable on small screens, grid on larger */}
          <div className="flex gap-4 md:gap-10 lg:gap-12 overflow-x-auto md:overflow-visible md:flex-wrap justify-center items-center scrollbar-thin scrollbar-thumb-slate-300/70 scrollbar-track-transparent">
            {logos.map((logo, index) => (
            
              <div
                key={index}
                className="flex-shrink-0 md:flex-shrink md:basis-[90px] lg:basis-[110px] flex justify-center"
              >
                <div className="group inline-flex items-center justify-center rounded-2xl bg-white border border-slate-100/70 shadow-sm px-4 py-2 md:px-4 md:py-3 transition-transform duration-200 hover:-translate-y-1 hover:shadow-[0_14px_30px_rgba(15,23,42,0.12)]">
                  <Image
                    src={logo.src}
                    alt={logo.alt}
                    className="h-10 md:h-12 lg:h-14 w-auto object-contain transition duration-200 group-hover:scale-105"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Helper text */}
          <p className="mt-4 text-[11px] md:text-xs text-center text-slate-400">
            Official recognitions and accreditation partnerships that reinforce the quality and credibility of our programs.
          </p>
        </div>
      </div>
    </section>
  );
}
